import * as React from 'react';

import { PromoSubtitle } from './PromoSubtitle';
import { PromoItem } from '../../../components/PromoItem';
import { IPromo } from '../../../types/newbuilding/promos';

interface IPromoContainerProps {
  onClick(promo: IPromo): void;
  promo: IPromo;
}

export const PromoItemContainer: React.FC<IPromoContainerProps> = ({ onClick, promo }) => {
  const handleClick = React.useCallback(() => {
    onClick(promo);
  }, [promo, onClick]);

  return <PromoItem promo={promo} subtitle={<PromoSubtitle promo={promo} />} onClick={handleClick} />;
};
